import ReactECharts from 'echarts-for-react';
import {useState, useEffect} from "react";
import Chart from "react-apexcharts";
import '../../.././../cssfiles/homepage.css';
import { useSelector } from "react-redux";
import dayjs from 'dayjs';
import moment from 'moment';
import CircularProgress from '@mui/material/CircularProgress';

const BarChart = (props) => {
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    const dateformatselected = useSelector((state) => state.mainpagedata.selecteddate);
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)
    const dateselected = useSelector((state) => state.mainpagedata.selecteddate)

    const [seriesChart, setSeriesChart] = useState([]);
    const [options, setOptions] = useState({});

    const theme = useSelector((state) => state.themedata.theme)
    const newdata = useSelector((state) => state.mainpagedata.updateddashboarddata)
    var tag_properties = props?.widgetprop?.props?.extended?.tagprops;
    var color_properties_bars = [];
    var width_properties_bars = [];
    var curve_properties_bars = [];
    var tagname_properties_bars = [];
    const color_map = new Map();

    const[type, setType]=useState('bar');

    useEffect(() => {
        const tagProperties = Array.isArray(props?.widgetprop?.props?.extended?.tagprops) 
    ? props.widgetprop.props.extended.tagprops 
    : [];

        const colorPropertiesGeneral = [];
        const colorPropertiesLines = [];
        const widthPropertiesLines = [];
        const curvePropertiesLines = [];
        const legendNamePropertiesLines = [];

        const colorPropertiesBars = [];
        const widthPropertiesBars = [];
        const curvePropertiesBars = [];
        const legendNamePropertiesBars = [];

        const colorPropertiesMarkers = [];
        const widthPropertiesMarkers = [];
        const curvePropertiesMarkers = [];
        const legendNamePropertiesMarkers = [];

        let isBarHorizontal = props?.widgetprop?.props?.extended?.horizontal;

        tagProperties.forEach(chartType => {
                if (chartType?.chartprops) {
                    colorPropertiesGeneral.push(chartType?.chartprops?.color);
                    colorPropertiesBars.push(chartType?.chartprops?.color);
                    widthPropertiesBars.push(2);
                    curvePropertiesBars.push('smooth');
                    legendNamePropertiesBars.push(chartType?.legendname);
                }
                
        });


        const seriesConsumed = tagProperties.map(chartType => {
            if (chartType && tagcollectionvalue.hasOwnProperty(chartType?.tagid)) {
                console.log("tagcollectionvalue[chartType.tagid] in MIXEDC HART",tagcollectionvalue[chartType?.tagid],"tagcollectionvalue",tagcollectionvalue)
                if(chartType?.charttype !== "maxlimit" && chartType?.charttype !== "minlimit"){
                    return {
                        name: chartType.legendname ?? '',
                        type: chartType.charttype ?? '',
                        data: 
                        
                        (tagcollectionvalue[chartType?.tagid] !== null && tagcollectionvalue[chartType?.tagid] !== undefined)?tagcollectionvalue[chartType?.tagid].map((currentobj)=>{
                            if (!currentobj) {
                                //console.error("Invalid or null-like value for currentobj:", currentobj);
                                return {
                                    x: '',
                                    y: null
                                };
                            }

                            
                             var currenttimestamp = currentobj?.x  ?? '';
                             const currentformatteddate = new Date(currenttimestamp);
                             var currxvalue;
                             console.log("here dateformatselected==============",currentformatteddate)
                              switch (dateformatselected) {
                                case 'This Year':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { month:"short"});
                                    break;
                                case 'Last Year':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { month:"short"});
                                    break;
                                case 'This Month':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { day:"numeric"});
                                    break;
                                case 'Last Month':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { day:"numeric"});
                                    break;
                                case 'This Week':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { weekday:"long"});
                                    break;
                                case 'Last Week':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { weekday:"long"});
                                    break;
                                case 'Today':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { hour:"numeric"});
                                    break;
                                case 'Yesterday':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { hour:"numeric"});
                                    break;
                                case 'Last 24 hours':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { hour:"numeric"})
                                    break;
                                case 'Custom':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { day:"numeric"})
                                    if(tagcollectionvalue[chartType.tagid].length > 30 ){
                                        var currentdaydate = currentformatteddate.getDate();
                                        if((currentdaydate == '1') || currentdaydate == 1){
                                            currxvalue = currentformatteddate.toLocaleDateString('en-us', {day:"numeric", month:"short"})
                                        }else{
                                            currxvalue = ''
                                        }
                                    }else if(tagcollectionvalue[chartType.tagid].length <= 30 ){
                                        currxvalue = currentformatteddate.toLocaleDateString('en-us', { day:"numeric"})
                                    }

                                    break;
                                
                            }
                            
                                    
                            console.log("mixed here currxvalue",tagcollectionvalue[chartType.tagid].length)
                            return({
                                x: currentobj?.x ?? '',
                                y: currentobj?.y ?? null
                            })
                                
                        }):null
                    };
                }
            }
            return null;
        }).filter(item => item !== null);

        const yaxisProperties = {
            forceNiceScale: true,
            labels: {
                show: true,
                style: {
                    colors: 'var(--axis-color)',
                    fontSize: props.widgetprop.props.extended.fontsize,
                    fontFamily: props.widgetprop.props.extended.fontfamily,
                    fontWeight: props.widgetprop.props.extended.fontweight,
                },
                formatter: (value) => { 
                    if(value == null){
                        return null
                    }else{
                        return value.toFixed(2) 
                    }
                    
                },
            },
            title: {
                text: props.widgetprop.props.extended.title.titlename ?? "",
                style: {
                    color: 'var(--axis-title-color)',
                    fontSize: props.widgetprop.props.extended.title.fontsize,
                    fontFamily: props.widgetprop.props.extended.title.fontfamily,
                    fontWeight: props.widgetprop.props.extended.title.fontweight,
                },
            },
        };

        const optionsConsumption = {
            chart: {
            type: "bar",
            zoom: {
                enabled: false,
            },
            toolbar: {
                show: false
            },
            stacked:props.widgetprop.props.extended.stacked,
            offsetX: 0
            },
            grid: {
            show: true,
            borderColor: 'var(--grey-variation)',
            },
            stroke: {
            show: true,
            width: [...widthPropertiesBars],
            curve: [...curvePropertiesBars],
            },
            fill: {
            opacity: 1,
            type: 'solid',
            },
            colors: [...colorPropertiesBars],
            plotOptions: {
            bar: {
                columnWidth: seriesConsumed[0]?.length>120?(seriesConsumed[0].length>100? '1%':'10%'):'30%',
                horizontal: isBarHorizontal,
                barGap: 30,       // Gap between bars to avoid overlap
                distributed: false,  // Distribute bars evenly
                rangeBarOverlap:false,
                rangeBarGroupRows: true,
                endingShape: 'flat', // Ensure bars have flat endings
                hideZeroBarsWhenGrouped:true,
            }
            },
            dataLabels: {
              enabled: props.widgetprop.props.extended.dataLabels_enabled
            },
            xaxis: {
            type:'datetime',
            tickAmount: seriesConsumed[0]?.data.length-1,
            tickPlacement:'between',
            tooltip: {
                enabled: false
            },
            axisBorder: {
                show: true,
                color: 'var(--axis-color)',
            },
            axisTicks: {
                show: true,
                height: 3,
                color: 'var(--axis-color)',
            },
            labels: {
                show: true,
                rotate: -45,
                rotateAlways: false,
                hideOverlappingLabels: true,
                style: {
                colors: 'var(--axis-color)',
                fontSize: props.widgetprop.props.extended.fontsize,
                fontFamily: props.widgetprop.props.extended.fontfamily,
                fontWeight: props.widgetprop.props.extended.fontweight,
                },
                formatter: function(value, timestamp, opts) {
                if (isNaN(value)) {
                    return '';
                }
                
                var index = opts?.i;
                //console.log("index in formatter",index,"props?.widgetprop?.props?.basic?.width",props?.widgetprop?.props?.basic?.width)
                var thistimestamp = index !== undefined ? opts.w.config.series[0]?.data[index]?.x : '';
                if (thistimestamp !== undefined && thistimestamp !== null && thistimestamp !== '') {
                    var currentformatteddate = new Date(thistimestamp);
                    var currxvalue = '';
                    var options = { timeZone: "Asia/Kolkata" };
                
                    switch (dateformatselected) {
                    case 'This Year':
                    case 'Last Year':
                        currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, month: "short" });
                        break;
                    case 'This Month':
                    case 'Last Month':
                    case 'Last 30 days':
                        currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric" });
                        break;
                    case 'This Week':
                    case 'Last Week':
                    case 'Last 7 days':
                        currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, weekday: "short" });
                        break;
                    case 'Today':
                    case 'Yesterday':
                        // var hrs = currentformatteddate.getHours();
                        // var hrsstring = hrs.toString().padStart(2, '0');
                        // currxvalue = hrsstring;
                        
                        // if ((dateformatselected === 'Today' && Number(props?.widgetprop?.props?.basic?.width) <= 6) || (dateformatselected === 'Yesterday' && Number(props?.widgetprop?.props?.basic?.width) <= 6)) {
                        //     if( index % 2 === 0){
                        //         currxvalue = ''
                        //     } else{
                        //         currxvalue = currxvalue
                        //     }
                        // }
                        // break;
                        var hrs=  currentformatteddate.getHours();
                        var hrsstring = hrs.toString();
                        if(hrsstring.length<2){
                            hrsstring = "0"+hrsstring;
                        }
                        currxvalue = hrsstring;
                        break;
                    case 'Last 24 hours':
                        var hrs = currentformatteddate.getHours();
                        var hrsstring = hrs.toString().padStart(2, '0');
                        var mins = currentformatteddate.getMinutes();
                        var minsstring = mins.toString().padStart(2, '0');
                        currxvalue = hrsstring + ":" + minsstring;
                        break;
                    case 'Custom':
                        if (seriesConsumed[0]?.data.length > 30) {
                        currxvalue = (currentformatteddate.getDate() === 1) 
                            ? currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short" }) 
                            : '';
                        } else {
                        currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric" });
                        }
                        break;
                    default:
                        currxvalue = '';
                        break;
                    }
                
                    return currxvalue || '';
                }
                }  
            },
            },
            yaxis: yaxisProperties,
            tooltip: {
            enabled: true,
            enabledOnSeries: undefined,
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
                const value = series[seriesIndex][dataPointIndex];
                const timestamp = w.globals.seriesX[seriesIndex][dataPointIndex];
            
                var currentFormattedDate = new Date(timestamp);
                
                var tooltipString = `<div style="display:flex; flex-direction:column; padding:5px; background-color:#005C8E;">`;
                const options = { 
                year: 'numeric', 
                month: '2-digit', 
                day: '2-digit', 
                hour: '2-digit', 
                minute: '2-digit', 
                hour12: false 
                  }; 
                var formattedDate = currentFormattedDate.toLocaleDateString('en-US', options).replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/g, '$3-$1-$2');;
        
                tooltipString += `<div style="font-weight:600; color:#FFFFFF;">${formattedDate}</div>`;
                for (var i = 0; i < series.length; i++) {
                const seriesValue = series[i][dataPointIndex];
                tooltipString += `
                <div style="display:flex; align-items:center; margin-bottom:4px;">
                    <div style="height:8px; width:8px; background-color:${w.config.colors[i]}; border-radius:50%; margin-right:8px;"></div>
                    <div style="font-weight:600; color:#FFFFFF;">${seriesConsumed[i].name}</div>
                    <div style="margin-left:12px; color:#FFFFFF;">${(seriesValue == null)?("No Value"):seriesValue.toFixed(2)}</div>
                </div>
                `;
                }
                tooltipString += `</div>`;
                return tooltipString;
            },
            hideEmptySeries: true,
            fillSeriesColor: false,
            theme: false,
            borderRadius:0,
            style: {
              fontSize: "12px",
              fontWeight: 800,
              fontFamily: 'Roboto',
            },
              },
            legend: {
            show: true,
            fontSize: props.widgetprop.props.extended.legend.fontsize,
            fontFamily: props.widgetprop.props.extended.legend.fontfamily,
            fontWeight: props.widgetprop.props.extended.legend.fontweight,
            labels: {
                colors: Array(colorPropertiesBars.length).fill('var(--legend-text-color)')
            },
            customLegendItems: [...legendNamePropertiesBars, ...legendNamePropertiesLines],
            markers: {
                radius: props.widgetprop.props.extended.legend.marker.radius,
                height: props.widgetprop.props.extended.legend.marker.height,
                width: props.widgetprop.props.extended.legend.marker.width,
                fillColors: [...colorPropertiesBars]
            }
            },
            responsive: [
                {
                    breakpoint: 1000,
                    options: {
                        xaxis: {
                            labels: {
                                rotate: -45,
                                rotateAlways: true,
                            }
                        }
                    }
                },
                {
                    breakpoint: 600,
                    options: {
                        xaxis: {
                            labels: {
                                rotate: -60,
                                rotateAlways: true,
                            }
                        }
                    }
                }
            ],
        };

        console.log("seriesConsumed in BarChart QSR",seriesConsumed)
        setSeriesChart(seriesConsumed);
        setOptions(optionsConsumption);
    }, [props.widgetprop, tagcollectionvalue]);

    return(
        <>  
            {/*console.log("seriesChart in barchart",seriesChart,"seriesChart[0]?.data",seriesChart[0]?.data)*/}
            {<Chart options={options} series={seriesChart} type="line" height="80%" width="100%" /> } 
        </>
    );
};

export default BarChart;






